<template>
  <div class="flex flex-col md:flex-row gap-6">
    <!-- Left: Vertical Thumbnail Gallery -->
    <!-- <div class="md:w-1/12 flex flex-col gap-3">
      <div
        v-for="(img, index) in productImages"
        :key="index"
        class="aspect-square overflow-hidden rounded cursor-pointer border-2 transition-all"
        :class="{
          'border-primary': activeThumbnail === index,
          'border-transparent hover:border-gray-300': activeThumbnail !== index
        }"
        @click="selectThumbnail(index)"
      >
        <img
          :src="img"
          :alt="product.name + ' thumbnail ' + (index + 1)"
          class="w-full h-full object-cover hover:scale-105 transition-transform"
        />
      </div>
    </div> -->

    <!-- Middle: Main Product Image (Detailed view) -->
    <div class="md:w-3/6">
      <div class="relative">
        <!-- Main Product Image with External Magnifier -->
        <div
          class="relative overflow-hidden rounded-lg border border-gray-200 aspect-square bg-white"
          @mousemove="showMagnifier"
          @mouseleave="hideMagnifier"
        >
          <!-- @mouseenter="magnifierVisible = true" -->
          <!-- Main image -->
          <img
            ref="mainImage"
            :src="productImages[activeThumbnail]"
            class="w-full h-full object-contain cursor-move"
          />
        </div>

        <!-- 图片预览 -->
        <div
          v-show="magnifierVisible"
          class="absolute w-full h-full top-0 right-[-470px] border border-gray-200 rounded-lg overflow-hidden shadow-xl z-50 bg-white"
          ref="magnifierBox"
        >
          <div
            class="w-full h-full transition-none"
            :style="magnifierStyle"
          ></div>
        </div>
      </div>

      <!-- 缩略图 -->
      <div class="mt-2 mx-3 flex flex-col md:flex-row gap-5">
        <div
          v-for="(img, index) in productImages"
          :key="index"
          class="aspect-square overflow-hidden rounded cursor-pointer border-2 transition-all"
          :class="{
            'border-primary': activeThumbnail === index,
            'border-transparent hover:border-gray-300':
              activeThumbnail !== index
          }"
          @click="selectThumbnail(index)"
        >
          <img
            :src="img"
            :alt="product.name + ' thumbnail ' + (index + 1)"
            class="w-full h-full object-cover hover:scale-105 transition-transform"
          />
        </div>
      </div>

      <!-- <div class="mt-2 mx-3 flex flex-col md:flex-row gap-5 relative">
        <div class="relative">
          <button
            v-show="productImages.length > 4"
            @click="scrollThumbnails('left')"
            class="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-white shadow rounded-full w-8 h-8 flex items-center justify-center text-gray-600 hover:bg-gray-50"
          >
            &lt;
          </button>

          <div
            ref="thumbnailsContainer"
            class="thumbnails-container flex space-x-2 overflow-x-auto pb-2 px-2"
            :class="{ 'px-8': productImages.length > 4 }"
            @scroll="updateScrollState"
          >
            <div
              v-for="(img, index) in productImages"
              :key="index"
              @click="selectThumbnail(index)"
              class="flex-shrink-0 cursor-pointer rounded"
              :class="{ 'thumbnail-active': index === currentIndex }"
            >
              <img :src="img" class="w-16 h-16 object-cover" />
            </div>
          </div>

          <button
            v-show="productImages.length > 4"
            @click="scrollThumbnails('right')"
            class="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-white shadow rounded-full w-8 h-8 flex items-center justify-center text-gray-600 hover:bg-gray-50"
          >
            &gt;
          </button>
        </div>
      </div> -->

      <!-- <div
        class="relative relative overflow-hidden rounded-lg border border-gray-200 aspect-square bg-white"
        @mousemove="showMagnifier"
        @mouseleave="hideMagnifier"
        @mouseenter="magnifierVisible = true"
      >
        <img
          ref="mainImage"
          :src="productImages[activeThumbnail]"
          :alt="product.name"
          class="w-full h-auto max-h-[500px] object-contain rounded-lg cursor-zoom-in"
        />
      </div> -->

      <!-- <div
        class="absolute md:w-3/6 top-0 w-72 h-72 border border-gray-200 rounded-lg overflow-hidden shadow-xl z-50 bg-white"
        ref="magnifierBox"
      >
        <div
          class="w-full h-full transition-none"
          :style="magnifierStyle"
        ></div>
      </div> -->
    </div>

    <!-- Right: Product Important Parameters -->
    <div class="md:w-3/6">
      <div class="rounded-lg rounded-lg h-full flex flex-col">
        <!-- <div class="flex-grow">
          <h3 class="text-dm font-bold text-[#555] mb-3">Short Description:</h3>

          <div class="space-y-2 text-sm text-[#555]">
            <p v-for="(item, index) in keyParameters" :key="index">
              {{ item.label }}: {{ item.value }}
            </p>
          </div>
        </div> -->
        <div class="title-container">
          <div class="title-bb">.</div>
          <div class="title-bg">
            <span>Short Description</span>
          </div>
        </div>

        <!-- 表格部分 -->
        <table class="w-full border border-gray-200 border-collapse mt-3">
          <tbody>
            <tr
              v-for="(item, index) in keyParameters"
              :key="index"
              :class="index % 2 === 0 ? 'bg-[#ececec]' : 'bg-white'"
            >
              <td
                class="text-[14px] text-gray-500 w-1/4 px-4 border border-gray-200"
              >
                {{ item.label }}
              </td>
              <td class="text-[14px] text-gray-500 px-4 border border-gray-200">
                {{ item.value }}
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Quick Action Buttons -->
        <div class="mt-8 flex flex-col md:flex-row gap-1">
          <button
            class="w-full text-[13px] px-1 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 flex items-center justify-center gap-1"
            @click="showQuestionDialg"
          >
            <i style="font-size: 16px" class="fa fa-envelope"></i>
            Ask a question
          </button>
          <button
            class="w-full text-[13px] px-1 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 flex items-center justify-center gap-1"
          >
            <i style="font-size: 16px" class="fa fa-file-pdf"></i>
            Download Catalog
          </button>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div
        v-if="showQuestingDialog"
        class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50"
      >
        <div
          class="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden transform transition-all"
        >
          <!-- <div
            class="px-6 py-4 border-b border-gray-100 flex justify-between items-center"
          >
            <h3 class="text-lg font-bold text-gray-800"></h3>
            <button
              @click="showModal = false"
              class="text-gray-400 hover:text-gray-600"
            >
              <span class="text-2xl">&times;</span>
            </button>
          </div> -->

          <div class="p-6">
            <form @submit.prevent="handleSubmit">
              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1"
                  >Name</label
                >
                <input
                  v-model="formData.name"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  placeholder="Please enter your name"
                  required
                />
              </div>
              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1"
                  >Email</label
                >
                <input
                  type="email"
                  v-model="formData.address"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  placeholder="Please enter your email address"
                  required
                />
              </div>
              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1"
                  >Leave a Message</label
                >
                <textarea
                  rows="4"
                  v-model="formData.message"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  placeholder="I'm interested in this product..."
                ></textarea>
              </div>

              <div class="mt-6 flex justify-end space-x-3">
                <button
                  type="button"
                  @click="showQuestingDialog = false"
                  class="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-md"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  class="px-4 py-2 bg-[#ff4d6d] text-white rounded-md hover:bg-[#e64460]"
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ProductImages',
  components: {},
  props: {
    productDetailPics: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    productDetailPics: {
      handler(newArr, oldArr) {
        this.activeThumbnail = 0
        this.processPicNames(newArr)
      }
    }
  },
  data() {
    return {
      product: [],
      activeThumbnail: 0,
      currentIndex: 0,
      productImages: [],
      magnifierVisible: false,
      showQuestingDialog: false,
      magnifierStyle: {
        backgroundImage: '',
        backgroundPosition: '0 0',
        backgroundSize: '0 0',
        backgroundRepeat: 'no-repeat'
      },
      zoomLevel: 2.5, // 2.5x zoom factor
      keyParameters: [],
      shortDescIndex: '0,0',
      formData: {
        name: '',
        address: '',
        productName: '',
        subject: '',
        message: ''
      }
    }
  },
  // watch: {
  //   product: {
  //     handler(newProduct) {
  //       if (newProduct) {
  //         this.activeThumbnail = 0
  //         this.loadProductImages(newProduct.id)
  //       }
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    showQuestionDialg() {
      if (this.productImages[this.activeThumbnail].indexOf('/') > -1) {
        let arr = this.productImages[this.activeThumbnail].split('/')
        this.formData.productName = arr[arr.length - 1]
      }
      this.showQuestingDialog = true
    },
    processPicNames(arr) {
      let productImages = []
      for (let i = 0; i < arr.length; i++) {
        productImages.push(arr[i].picPath)
      }
      this.productImages = productImages
    },
    loadProductImages(productId) {
      // Generate multiple images for each product
      // let baseUrl = 'https://via.placeholder.com/600x600?text=Product' + productId
      this.productImages = [
        'https://cdn.globalso.com/deergifts/%E4%B8%BB%E5%9B%BE2111-600x600.jpg',
        'https://cdn.globalso.com/deergifts/%E4%B8%BB%E5%9B%BE3104-600x600.jpg',
        'https://cdn.globalso.com/deergifts/%E4%B8%BB%E5%9B%BE3104-600x600.jpg',
        'https://cdn.globalso.com/deergifts/%E4%B8%BB%E5%9B%BE3104-600x600.jpg'
      ]
    },
    selectThumbnail(index) {
      this.activeThumbnail = index
    },
    zoomImage() {
      // In a real application, this would open a modal with zoomed image
      alert('Image zoom feature would be implemented here')
    },
    formatDate(date) {
      const d = new Date(date)
      return d.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })
    },
    showMagnifier(event) {
      if (!this.magnifierVisible) return

      const container = event.currentTarget
      const rect = container.getBoundingClientRect()
      const image = this.$refs.mainImage
      const magnifierBox = this.$refs.magnifierBox

      if (!image || !magnifierBox) return

      // Get dimensions
      const containerWidth = rect.width
      const containerHeight = rect.height
      const magnifierWidth = magnifierBox.offsetWidth
      const magnifierHeight = magnifierBox.offsetHeight

      // Calculate mouse position relative to container
      const mouseX = event.clientX - rect.left
      const mouseY = event.clientY - rect.top

      // Calculate the ratio of mouse position to container size (0-1)
      const xRatio = mouseX / containerWidth
      const yRatio = mouseY / containerHeight

      // console.log(magnifierWidth, magnifierHeight, xRatio, yRatio)
      // Set background image and size for the magnifier
      const imgUrl = this.productImages[this.activeThumbnail]
      this.magnifierStyle.backgroundImage = `url(${imgUrl})`
      // console.log(imgUrl)

      // Calculate background size (original image size * zoom factor)
      // Since we don't know the original size, we'll use a calculated size based on container
      // and zoom level to ensure proper scaling
      const bgWidth = containerWidth * this.zoomLevel
      const bgHeight = containerHeight * this.zoomLevel
      this.magnifierStyle.backgroundSize = `${bgWidth}px ${bgHeight}px`

      // Calculate ideal background position
      let bgPosX = -(xRatio * bgWidth - magnifierWidth / 2)
      let bgPosY = -(yRatio * bgHeight - magnifierHeight / 2)

      // Add boundary checks to prevent showing empty space
      // Left boundary
      const maxX = 0
      // Right boundary (background width - magnifier width)
      const minX = -(bgWidth - magnifierWidth)
      // Top boundary
      const maxY = 0
      // Bottom boundary (background height - magnifier height)
      const minY = -(bgHeight - magnifierHeight)

      // Constrain background position within boundaries
      bgPosX = Math.max(Math.min(bgPosX, maxX), minX)
      bgPosY = Math.max(Math.min(bgPosY, maxY), minY)

      // Apply the constrained background position
      this.magnifierStyle.backgroundPosition = `${bgPosX}px ${bgPosY}px`
    },
    hideMagnifier() {
      this.magnifierVisible = false
    },
    handlecategorySelected(item, subItem) {
      const shortDescIndex = item.index + ',' + item.end
      // console.log(this.shortDescIndex, shortDescIndex)
      if (this.shortDescIndex !== shortDescIndex) {
        this.loadShortDesc(item.index, item.end)
        this.shortDescIndex = shortDescIndex
      }
      if (!subItem || subItem === 'null') {
        subItem = ''
      }
      this.loadPicName(item.category, subItem)
    },
    // 获取简介
    loadShortDesc(start, end) {
      this.$api.sysApi.getShortDesc(start, end).then((res) => {
        this.keyParameters = res.data
      })
    },
    // 获取图片
    loadPicName(category, subCategory) {
      if (category.indexOf('&') > -1) {
        category = category.replace('&', '*')
      }
      this.activeThumbnail = 0
      this.$api.sysApi.getPicName(category, subCategory).then((res) => {
        let path = `https://pic.deergifts.com/${category}/`
        if (subCategory) {
          path += `${subCategory}/`
        }
        if (category.indexOf('*') > -1) {
          category = category.replace('*', '&')
          path = path.replace('*', '&')
        }
        const imgUrls = []
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            imgUrls.push(path + res.data[i])
          }
        }
        this.productImages = JSON.parse(JSON.stringify(imgUrls))
      })
    },
    // ========================================
    scrollThumbnails(direction) {
      const container = this.$refs.thumbnailsContainer
      const scrollAmount = 200

      if (direction === 'left') {
        container.scrollLeft -= scrollAmount
      } else {
        container.scrollLeft += scrollAmount
      }
    },
    scrollToThumbnail(index) {
      const container = this.$refs.thumbnailsContainer
      const thumbnailWidth = 68 // 缩略图宽度 + 间距
      const scrollTo =
        index * thumbnailWidth - container.clientWidth / 2 + thumbnailWidth / 2

      container.scrollTo({
        left: scrollTo,
        behavior: 'smooth'
      })
    },
    updateScrollState() {
      const container = this.$refs.thumbnailsContainer
      this.scrollPosition = container.scrollLeft
    },
    updateScrollInfo() {
      const container = this.$refs.thumbnailsContainer
      if (container) {
        this.containerWidth = container.clientWidth
        this.scrollWidth = container.scrollWidth
        this.scrollPosition = container.scrollLeft
      }
    },
    handleSubmit() {
      // console.log(JSON.stringify(this.formData))
      this.$api.sysApi
        .sendEmail(this.formData)
        .then((res) => {
          // this.submitStatus = 'success'
          this.showQuestingDialog = false
          alert('Message sent successfully!')
        })
        .catch((err) => {
          console.log(err)
          alert('Message sent fail!')
        })
    }
  },
  mounted() {
    this.$bus.$on('category-selected', this.handlecategorySelected)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title-container {
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  width: 100%;
}
.title-bg {
  background-color: var(--primary);
  color: white;
  padding: 5px 24px 5px 16px;
  font-size: 15px;
  position: relative;
  display: inline-flex;
  align-items: center;
  clip-path: polygon(0% 0%, calc(100% - 24px) 0%, 100% 100%, 0% 100%);
}
.title-bb {
  position: absolute;
  margin-top: 9px;
  right: 0;
  left: 0;
  background: #e2e2e2;
}
/* 简单的淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/page/products/ProductImages.vue